import React, { PropTypes, Component } from 'react';
import _ from 'underscore';
import Dropzone from 'react-dropzone';
import alertify from 'alertify.js';

import { uploadImage } from '../core/utils/api';
import ToolTip from './ToolTip';

const dropZoneStyle = {
    width: '600px',
    height: '50px',
    borderWidth: '1px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '10px',
    marginBottom: '10px'
};

class FileInputGroup extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isUpload: false
        };
    }

    onDrop = (acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const { onChange } = this.props;

            uploadImage(file)
                .then((response) => {
                    console.log(response);
                    onChange(response.data.image);
                    this.setState({ isUpload: true });
                })
                .catch((error) => {
                    console.log('upload error', error);
                    alertify.error('Unable to upload your image');
                });
        });
    }

    render() {
        const { label, toolTip } = this.props;
        const { isUpload } = this.state;

        return (
            <div className="field">
                <label>
                    {label}
                    {!_.isUndefined(toolTip) ? <ToolTip text={toolTip} /> : null}
                </label>
                <Dropzone onDrop={this.onDrop.bind(this)} style={dropZoneStyle}>
                    {!isUpload ?
                        <div>Try dropping some files here, or click to select files to upload.</div>
                    :
                        <div>Image uploaded sucessfully.</div>
                    }
                </Dropzone>
            </div>
        );
    }
}

FileInputGroup.propTypes = {
    label: PropTypes.string.isRequired,
    toolTip: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default FileInputGroup;



/** WEBPACK FOOTER **
 ** ./src/elements/FileInputGroup.js
 **/